import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createVNode as _createVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/img/training_registration.jpg'


const _withScopeId = n => (_pushScopeId("data-v-f3a2d70a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "relative md:min-h-screen min-h-[80vh] w-full mb-8" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<section class=\"relative lg:h-[500px] md:h-[400px] h-[300px] w-full flex flex-col justify-center\" data-v-f3a2d70a><img class=\"absolute object-cover w-full h-full block z-0\" src=\"" + _imports_0 + "\" alt=\"\" data-v-f3a2d70a><div class=\"absolute h-full w-full z-10\" style=\"background-color:rgba(0, 0, 0, 0.7);\" data-v-f3a2d70a> </div><div class=\"w-full relative p-auto z-20\" data-v-f3a2d70a><h1 class=\"lg:text-4xl md:text-2xl text-xl font-extrabold text-center text-white mb-6\" data-v-f3a2d70a>Prêt à plonger dans le monde passionnant de la cybersécurité ?</h1><p class=\"text-center text-white md:text-xl lg:lg\" data-v-f3a2d70a>Complétez le formulaire ci-dessous pour accéder à tous les détails sur notre formation <span class=\"text-primary font-bold\" data-v-f3a2d70a>Introduction à la Cybersécurité</span>.</p></div></section>", 1)
const _hoisted_3 = { class: "relative lg:-mt-16 md:-mt-12 -mt-8 z-30 lg:w-3/4 md:w-5/6 w-[90%] mx-auto md:p-6 p-4 shadow-lg bg-white" }
const _hoisted_4 = ["onSubmit"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "text-primary lg:text-3xl md:text-2xl text-xl font-bold text-center mb-8" }, "Enregistrez vous", -1))
const _hoisted_6 = { class: "w-full mb-8 grid grid-cols-2 gap-4 justify-start" }
const _hoisted_7 = { class: "col-span-full" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "text-sm font-bold text-black-500 block mb-2",
  for: "fullnameInput"
}, "Nom Complet", -1))
const _hoisted_9 = { class: "lg:col-span-1 col-span-full" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "text-sm font-bold text-black-500 block mb-2",
  for: "emailInput"
}, "Email", -1))
const _hoisted_11 = { class: "lg:col-span-1 col-span-full" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "text-sm font-bold text-black-500 block mb-2",
  for: "phoneNumberInput"
}, "Téléphone", -1))
const _hoisted_13 = { class: "flex flex-row w-full" }
const _hoisted_14 = { value: "+229" }
const _hoisted_15 = { value: "+226" }
const _hoisted_16 = { value: "+238" }
const _hoisted_17 = { value: "+225" }
const _hoisted_18 = { value: "+220" }
const _hoisted_19 = { value: "+233" }
const _hoisted_20 = { value: "+224" }
const _hoisted_21 = { value: "+245" }
const _hoisted_22 = { value: "+231" }
const _hoisted_23 = { value: "+223" }
const _hoisted_24 = { value: "+227" }
const _hoisted_25 = { value: "+234" }
const _hoisted_26 = { value: "+221" }
const _hoisted_27 = { value: "+232" }
const _hoisted_28 = { value: "+228" }
const _hoisted_29 = ["disabled"]
const _hoisted_30 = {
  key: 0,
  class: "fas fa-spinner fa-spin"
}
const _hoisted_31 = { key: 1 }

import { ref, onMounted } from 'vue';
import { useRouter } from 'vue-router'
import axios from 'axios';
import axiosInstance from '@/plugins/axios';
import FooterComponent from '@/components/FooterComponent.vue';



export default /*#__PURE__*/_defineComponent({
  __name: 'RegisterTrainingProspect',
  setup(__props) {

const router = useRouter();

const loading = ref(false);

const prospectRegistrationData = ref({
    fullname: "",
    email: "",
    phone_number: "",
    phone_number_code: "+229",
})

const isoToEmoji = (code) => {
  return code
    .split('')
    .map(letter => letter.charCodeAt(0) % 32 + 0x1F1E5)
    .map(emojiCode => String.fromCodePoint(emojiCode))
    .join('')
}

const registerTrainingProspect = async () => {
    try {
        loading.value = true;
        prospectRegistrationData.value.phone_number = prospectRegistrationData.value.phone_number_code + prospectRegistrationData.value.phone_number
        const response = await axiosInstance.post('/training-prospects/', prospectRegistrationData.value);
    } finally {
        setTimeout(() => {
            router.push('/training-cybersecurity');
        }, 1000);

        loading.value = false; 
    }

};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("main", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("section", _hoisted_3, [
        _createElementVNode("form", {
          onSubmit: _withModifiers(registerTrainingProspect, ["prevent"]),
          class: "m-auto lg:p-8 md:p-6 p-4 border-primary"
        }, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((prospectRegistrationData.value.fullname) = $event)),
                class: "rounded-[5px] border border-slate-300 outline-none bg-transparent w-full py-4 px-[10px]",
                type: "text",
                placeholder: "John Doe",
                required: "",
                id: "fullnameInput"
              }, null, 512), [
                [_vModelText, prospectRegistrationData.value.fullname]
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((prospectRegistrationData.value.email) = $event)),
                class: "rounded-[5px] border border-slate-300 outline-none bg-transparent w-full py-4 px-[10px]",
                type: "email",
                placeholder: "johndoe@gmail.com",
                required: "",
                id: "emailInput"
              }, null, 512), [
                [_vModelText, prospectRegistrationData.value.email]
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _createElementVNode("div", _hoisted_13, [
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((prospectRegistrationData.value.phone_number_code) = $event)),
                  class: "rounded-[5px] border border-r-transparent rounded-tr-none rounded-br-none border-slate-300 outline-none bg-transparent w-auto py-4 px-[10px]"
                }, [
                  _createElementVNode("option", _hoisted_14, _toDisplayString(isoToEmoji('BJ')) + " +229", 1),
                  _createElementVNode("option", _hoisted_15, _toDisplayString(isoToEmoji('BF')) + " +226", 1),
                  _createElementVNode("option", _hoisted_16, _toDisplayString(isoToEmoji('CV')) + " +238", 1),
                  _createElementVNode("option", _hoisted_17, _toDisplayString(isoToEmoji('CI')) + " +225", 1),
                  _createElementVNode("option", _hoisted_18, _toDisplayString(isoToEmoji('GM')) + " +220", 1),
                  _createElementVNode("option", _hoisted_19, _toDisplayString(isoToEmoji('GH')) + " +233", 1),
                  _createElementVNode("option", _hoisted_20, _toDisplayString(isoToEmoji('GN')) + " +224", 1),
                  _createElementVNode("option", _hoisted_21, _toDisplayString(isoToEmoji('GW')) + " +245", 1),
                  _createElementVNode("option", _hoisted_22, _toDisplayString(isoToEmoji('LR')) + " +231", 1),
                  _createElementVNode("option", _hoisted_23, _toDisplayString(isoToEmoji('ML')) + " +223", 1),
                  _createElementVNode("option", _hoisted_24, _toDisplayString(isoToEmoji('NE')) + " +227", 1),
                  _createElementVNode("option", _hoisted_25, _toDisplayString(isoToEmoji('NG')) + " +234", 1),
                  _createElementVNode("option", _hoisted_26, _toDisplayString(isoToEmoji('SN')) + " +221", 1),
                  _createElementVNode("option", _hoisted_27, _toDisplayString(isoToEmoji('SL')) + " +232", 1),
                  _createElementVNode("option", _hoisted_28, _toDisplayString(isoToEmoji('TG')) + " +228", 1)
                ], 512), [
                  [_vModelSelect, prospectRegistrationData.value.phone_number_code]
                ]),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((prospectRegistrationData.value.phone_number) = $event)),
                  class: "box-border rounded-[5px] border rounded-tl-none rounded-bl-none border-slate-300 outline-none bg-transparent grow py-4 px-[10px] w-[40px]",
                  type: "tel",
                  pattern: "^\\d{8,15}$",
                  placeholder: "99999999",
                  required: "",
                  id: "phoneNumberInput"
                }, null, 512), [
                  [_vModelText, prospectRegistrationData.value.phone_number]
                ])
              ])
            ])
          ]),
          _createElementVNode("button", {
            type: "submit",
            disabled: loading.value,
            class: "py-[12px] md:w-[200px] w-auto px-[30px] rounded-[5px] text-md font-bold text-white bg-primary hover:bg-cyan-600 duration-300 block mx-auto"
          }, [
            (loading.value)
              ? (_openBlock(), _createElementBlock("i", _hoisted_30))
              : (_openBlock(), _createElementBlock("span", _hoisted_31, "Enregistrer"))
          ], 8, _hoisted_29)
        ], 40, _hoisted_4)
      ])
    ]),
    _createVNode(FooterComponent)
  ], 64))
}
}

})